import React, { useRef, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import Popover from '@mui/material/Popover';
import Fade from '@mui/material/Fade';
import { useTheme } from 'styled-components';

import { UserInfoContainerProps } from 'components/side-menu/user-info-container/user-info-container.props';
import UserIcon from 'components/breadcrumbs-panel-dashboard/user-icon/index';
import UserInfo from 'components/side-menu/user-info';
import { Distance, Flex } from 'common/common-components.styled';

import { getMenuItemsPaperProps } from 'components/side-menu/menu-item/menu-item';
import { PAGES } from 'common/enums';

import { useUnsavedChangesModal } from 'hooks/modals/unsaved-changes.modal/unsaved-changes.modal';
import { useIsUserHaveRole } from 'hooks/use-is-user-have-role';
import { USER_ROLES } from '../../../constants';
import { useTypedSelector } from 'hooks/use-typed-selector';

const UserInfoContainer = ({ isMinimized }: UserInfoContainerProps) => {
  const theme = useTheme();
  const isSiteAvailable = useTypedSelector(state => state.app.isSiteAvailable);
  const history = useHistory();

  const [open, setOpen] = useState(false);
  const userIcon = useRef<HTMLDivElement | null>(null);
  const popover = useRef<HTMLDivElement | null>(null);

  const { openUnsavedChangesModal } = useUnsavedChangesModal();
  const isAllowSettings = !useIsUserHaveRole([USER_ROLES.dealer.id, USER_ROLES.leasingcompany.id]);

  const openPopover = () => {
    setOpen(true);
  };

  const closePopover = () => {
    setOpen(false);
  };

  const goToUserSettings = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    if (e.ctrlKey || e.metaKey || e.button === 1) {
      return;
    }

    if (isAllowSettings && isSiteAvailable) {
      e.preventDefault();
      closePopover?.();
      openUnsavedChangesModal(() => {
        history.push(PAGES.ACCOUNT_SETTINGS);
      });
    }
  };

  const defaultPaperProps = getMenuItemsPaperProps(theme, openPopover, closePopover);

  const userIconClickHandler = () => {
    isMinimized && openPopover();
  };

  return (
    <>
      <div onMouseEnter={userIconClickHandler} onMouseLeave={closePopover} ref={userIcon}>
        <Link to={PAGES.ACCOUNT_SETTINGS} onClick={event => goToUserSettings(event)}>
          <UserIcon onClick={goToUserSettings} />
        </Link>
      </div>

      {isMinimized ? (
        <Popover
          ref={popover}
          sx={{
            pointerEvents: 'none'
          }}
          anchorOrigin={{
            vertical: 'center',
            horizontal: 'right'
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left'
          }}
          open={open}
          anchorEl={userIcon.current}
          onClose={closePopover}
          PaperProps={{
            ...defaultPaperProps,
            sx: { ...defaultPaperProps.sx, ml: 2 }
          }}
          TransitionComponent={Fade}
        >
          <Flex padding='15px 20px'>
            <UserInfo goToUserSettings={goToUserSettings} />
          </Flex>
        </Popover>
      ) : (
        <>
          <Distance side='10' />
          <UserInfo goToUserSettings={goToUserSettings} />
        </>
      )}
    </>
  );
};

export default UserInfoContainer;
